import { Flex } from '@chakra-ui/react'
import { parseJwt } from '../../../../services/token'

export interface iStatusAssessment {
  id: number
  titulo: string
}

export const StatusAssessments: iStatusAssessment[] = [
  { id: 0, titulo: 'Novo' },
  { id: 1, titulo: 'Aguardando processamento' },
  { id: 2, titulo: 'Processando' },
  { id: 3, titulo: 'Concluído e oculto' },
  { id: 4, titulo: 'Concluído e liberado' },
  { id: 5, titulo: 'Processando linkedin' },
  { id: 6, titulo: 'Aguardando linkedin' },
  { id: 7, titulo: 'Aguardando PI do candidato' },
  { id: 8, titulo: 'Aguardando PI do gestor' },
  { id: 9, titulo: 'Erro' },
  { id: 10, titulo: 'Aguardando revisão' },
  { id: 11, titulo: 'Aguardando relacionamento' },
  { id: 12, titulo: 'Processando relacionamento' },
  { id: 13, titulo: 'Nova solicitação' },
  { id: 14, titulo: 'Aguardando processamento Galaxy' },
  { id: 15, titulo: 'Processando Galaxy' },
  { id: 16, titulo: 'Erro Galaxy' }
]

export const StatusRevisaoAh = 10

// cliente enxerga as etapas do Galaxy como o status comum equivalente
const StatusEquivalenteCliente: Record<number, number> = { 14: 1, 15: 2, 16: 9 }

export function VerTodosStatus(tipoAcesso: number): boolean {
  const jwt = parseJwt()
  return tipoAcesso === 1 || jwt.cid === 'a5ee6794-41de-4163-983b-b3e66912b72e' || jwt.cid === 'eaa268cc-85c3-4fbc-96a5-349e33df27bf'
}

export function GetStatusVisiveis(verTodos: boolean): iStatusAssessment[] {
  return verTodos ? StatusAssessments : StatusAssessments.filter(e => StatusEquivalenteCliente[e.id] === undefined)
}

function GetStatusExibido(status: number, verTodos: boolean): number {
  return verTodos ? status : StatusEquivalenteCliente[status] ?? status
}

export function GetStatusTitulo(status: number, verTodos = false): string {
  const exibido = GetStatusExibido(status, verTodos)
  return StatusAssessments.find(e => e.id === exibido)?.titulo ?? ''
}

export function GetStatusCor(status: number): string {
  if (status === 9 || status === 16) {
    return 'var(--Red)'
  }

  if (status === 3 || status === 4) {
    return 'var(--Green2)'
  }

  if (status === 0) {
    return 'var(--Gray2)'
  }

  return 'var(--Orange)'
}

export function GetStatus(status: number, verTodos = false): JSX.Element {
  return <Flex as='strong' color={GetStatusCor(GetStatusExibido(status, verTodos))} fontWeight={600}>{GetStatusTitulo(status, verTodos)}</Flex>
}
